
export default {
    getVesselActivities: (state) => state.vesselActivities,
}